import { render, staticRenderFns } from "./PlansPage.vue?vue&type=template&id=3d78f318"
import script from "./PlansPage.vue?vue&type=script&lang=js"
export * from "./PlansPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports